<!--TODO: btr way to pass id to delete method without using selectedId property? refine code for popup on view--> 

<template>
  <v-container class="p-0">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <!--delete confirmation dialog-->
    <Dialog
      :title="'Are you sure you want to delete this item?'"
      :text="'This action is not reversible.'"
      :rejectButtonText="'No'"
      :acceptButtonText="'Yes'"
      :toggle="dialog"
      @reject="dialog = false"
      @accept="confirmDeleteItem"
    />

    <!--popup when user clicks on view-->
    <v-dialog v-model="newsEventsPreview" max-width="450px" overlay-opacity="0">
      <v-card
        class="news-card"
        @click="newsEventsRedirect(newsEventsPreviewDetails.message.url)"
        :style="{ backgroundImage: 'url(' + previewBg + ')' }"
      >
        <div class="title">{{ newsEventsPreviewDetails.message.title }}</div>
        <div class="desc">{{ newsEventsPreviewDetails.message.desc }}</div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" md="7" class="pt-0">
        <div class="header text-left">Manage Homepage - News and Events</div>
      </v-col>
      <v-col cols="12" md="5" class="action-buttons pt-0">
        <v-btn class="filter-btn" color="#FDBB30">Filter</v-btn>
        <v-btn class="create-btn" color="#00457C" @click="createNewsEvents"
          >Create News and Events Item</v-btn
        >
      </v-col>
    </v-row>

    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" class="pt-0">
        <!-- Table -->
        <TableComponent
          type="popup"
          v-bind:dynamicHeaders="dynamicHeaders"
          v-bind:dynamicWidths="dynamicWidths"
          v-bind:dynamicRowsDetail="dynamicRowsDetail"
          v-on:view-item="viewPopup"
          v-on:edit-item="editPopup"
          v-on:delete-item="deletePopup"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TableComponent from "./commons/TableComponent";
import Axios from "axios";
import Dialog from "./commons/Dialog";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    TableComponent,
    Dialog,
    LoadingScreen,
  },
  created() {
    Axios.get(process.env.VUE_APP_HOST_SERVER + "/api/news-events")
      .then((res) => {
        console.log("Successfully retrieved all details");
        this.rawNewsEventsPreviewDetails = res.data;
        this.dynamicRowsDetail = this.processFetchedData(res.data);
      })
      .catch((err) => console.log(err));
  },
  data() {
    return {
      dynamicHeaders: [
        { text: "Title", value: "title", width: 200 },
        { text: "Content", value: "content", width: 300 },
        { text: "Sequence", value: "sequence", width: 100 },
        { text: "Actions", value: "actions" },
      ],
      dynamicWidths: ["150px", "150px", "150px", "50px"],
      dynamicRowsDetail: [],
      dialog: false,
      selectedId: "",
      newsEventsPreview: false,
      rawNewsEventsPreviewDetails: [],
      newsEventsPreviewDetails: {
        message: {
          title: "",
          desc: "",
          url: "",
          imageUrl: "",
        },
      },
      loading: false,
      error: false,
    };
  },

  computed: {
    previewBg() {
      return "'" + this.newsEventsPreviewDetails.message.imageUrl + "'";
    },
  },

  methods: {
    processFetchedData(rawData) {
      return rawData.map(({ _id, message, sequence }) => {
        return {
          rowId: _id,
          title: message.title,
          content: message.desc,
          url: message.url,
          sequence: sequence,
          action: { view: "show", delete: "show", edit: "show" },
        };
      });
    },
    viewPopup(id) {
      this.newsEventsPreview = true;
      this.newsEventsPreviewDetails = this.rawNewsEventsPreviewDetails.find(
        (item) => item._id === id
      );
    },
    editPopup(id) {
      this.$router
        .push({
          name: "EditHomepageNewsEvents",
          params: { itemId: id },
        })
        .catch(() => {});
    },

    deletePopup(id) {
      //this.$store.dispatch('openDialog');
      this.dialog = true;
      this.selectedId = id;
    },

    confirmDeleteItem() {
      this.loading = true; //enable loading screen once user clicks delete

      this.dialog = false;

      let id = this.selectedId;

      let url = this.rawNewsEventsPreviewDetails.find((item) => item._id === id)
        .message.imageUrl;

      Axios.post(process.env.VUE_APP_HOST_SERVER + "/api/news-events/delete", {
        id: id,
      }).then(() => {
        console.log("Successfully deleted item from DB");
        Axios.delete(process.env.VUE_APP_HOST_SERVER + "/api/file/delete", {
          data: {
            s3Url: url,
          },
        })
          .then(() => {
            let deleteIndex = this.dynamicRowsDetail.findIndex(
              (item) => item.rowId === id
            );

            this.dynamicRowsDetail.splice(deleteIndex, 1);

            this.selectedId = "";

            this.loading = false; //disable loading screen once request is handled;

            this.error = false;
          })
          .catch((err) => {
            console.log(err);
            this.error = true;
          });
      });
    },

    createNewsEvents() {
      this.$router.push({ name: "AddHomepageNewsEvents" });
    },

    newsEventsRedirect(url) {
      window.open(url);
    },
  },
};
</script>

<style>
.news-card {
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 25px;
  max-width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.news-card .title {
  font-size: 16px !important;
  margin-bottom: 5px;
  color: white;
}

.news-card .desc {
  letter-spacing: -0.01px;
  font-size: 14px !important;
  color: white;
}
</style>
